var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-legal-text bcx-scrollbar bcx-all bcx-secondary"},[_c('BCXMarkdown',{staticClass:"bcx-legal-text",attrs:{"tag":"div","unstyled":"","text":_vm.$t(`legaltexts.${_vm.legalText}.text`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }